const C = {
  name: "Scale",
  dimensions: { width: 40, height: 41 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_27_2122)">
    <path d="M39.001 40.0029H1.00098C0.400977 40.0029 0.000976562 39.6029 0.000976562 39.0029V1.00293C0.000976562 0.40293 0.400977 0.00292969 1.00098 0.00292969H39.001C39.601 0.00292969 40.001 0.40293 40.001 1.00293V39.0029C40.001 39.6029 39.601 40.0029 39.001 40.0029ZM3.00098 38.0029H38.001V3.00293C38.001 2.40293 37.601 2.00293 37.001 2.00293H2.00098V37.0029C2.00098 37.6029 2.40098 38.0029 3.00098 38.0029Z" />
    <path d="M32.4009 10.503C25.6009 3.70295 14.5009 3.70295 7.70088 10.503C7.30088 10.903 7.30088 11.503 7.70088 11.903L13.4009 17.603C13.8009 18.003 14.4009 18.003 14.8009 17.603C16.2009 16.203 18.1009 15.403 20.1009 15.403C21.0009 15.403 21.8009 15.603 22.6009 15.803L22.7009 15.903C22.8009 15.903 22.8009 15.903 22.9009 15.903C23.8009 16.303 24.6009 16.803 25.4009 17.503C25.6009 17.703 25.8009 17.803 26.1009 17.803C26.4009 17.803 26.6009 17.703 26.8009 17.503L32.5009 11.803C32.8009 11.603 32.8009 10.903 32.4009 10.503ZM26.0009 15.503C25.5009 15.103 24.9009 14.703 24.3009 14.403L25.0009 12.303C25.2009 11.803 24.9009 11.203 24.4009 11.003C23.9009 10.803 23.3009 11.103 23.1009 11.603L22.4009 13.603C21.6009 13.403 20.8009 13.303 20.0009 13.303C17.8009 13.303 15.7009 14.003 14.0009 15.403L9.70088 11.103C15.5009 6.00295 24.3009 6.00295 30.2009 11.103L26.0009 15.503Z" />
    </g>
    <defs>
    <clipPath id="clip0_27_2122">
    <rect width="40" height="40" fill="currentColor" transform="translate(0.000976562 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>
  `
};
export {
  C as Scale
};
